import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';

import styles from './SearchByShip.module.scss';

import { Schedule } from '../types';
import SearchForm from './SearchForm/SearchForm';
import SearchResult from './SearchResult/SearchResult';
import { getModificationHistory } from '../getModificationHistory';
import { getScheduleFecha } from '../getScheduleFecha';
import { getSchedule } from '../getSchedule';

type SearchByShipProps = {
  schedule?: Schedule[];
};

const SearchByShip: FC<SearchByShipProps> = () => {
  const { t } = useTranslation('schedule');

  // Obtengo los schedules para el combobox desde getScheduleFecha
  const { data: scheduleFecha } = useQuery({
    queryKey: ['schedule-fecha'],
    queryFn: getScheduleFecha,
  });

  const { data: schedule } = useQuery({
    queryKey: ['schedule'],
    queryFn: getSchedule,
  });

  const [searchResult, setSearchResult] = useState<Schedule | null | undefined>(
    null
  );

  const {
    data: modificationsTableData,
    mutate: getModificationHistoryMutate,
    isPending: modificationsTableDataLoading,
  } = useMutation({
    mutationKey: ['Exchanges'],
    mutationFn: () => getModificationHistory(Number(searchResult?.codigo)),
  });

  const handleSearch = (selected: Schedule) => {
    setSearchResult(selected);
    getModificationHistoryMutate();
  };

  const clearResult = () => {
    setSearchResult(null);
  };

  return (
    <div className={styles.searchByShip}>
      <div>
        <h2>{t('searchByShipForm.title')}</h2>
        <p>{t('searchByShipForm.description')}</p>
        <SearchForm
          schedule={[...(schedule || []), ...(scheduleFecha || [])]}
          onSubmit={handleSearch}
          clearResult={clearResult}
        />
      </div>
      <div>
        {searchResult && (
          <SearchResult
            result={searchResult}
            modificationsTableData={modificationsTableData ?? []}
            modificationsTableDataLoading={modificationsTableDataLoading}
          />
        )}
      </div>
    </div>
  );
};

export default SearchByShip;
